import { useContext } from 'react';
import { CustomerChatbotContext } from '../context/customer-chatbot-context';

export function useCustomerChatbotContext() {
  return useContext(CustomerChatbotContext);
}
